import {
  IconHome,
  IconPort,
  IconWarning,
  type IconComponent
} from '@gat-ship/icons'

/** The sidebar tabs of the agency detail modal. */
export const AGENCY_DETAIL_SECTIONS = [
  'general',
  'ports',
  'danger-zone'
] as const

export type AgencyDetailSection = (typeof AGENCY_DETAIL_SECTIONS)[number]

export interface AgencyDetailSidebarItem {
  key: AgencyDetailSection
  label: string
  icon: IconComponent
}

/**
 * Sidebar items for the agency detail modal: General, Ports, Danger Zone.
 */
export function getAgencyDetailSidebarItems(): AgencyDetailSidebarItem[] {
  return [
    { key: 'general', label: 'General', icon: IconHome },
    { key: 'ports', label: 'Ports', icon: IconPort },
    { key: 'danger-zone', label: 'Danger Zone', icon: IconWarning }
  ]
}

/** Validate a raw query value into a known section, defaulting to `general`. */
export function toValidAgencySection(
  value: string | null
): AgencyDetailSection {
  return AGENCY_DETAIL_SECTIONS.includes(value as AgencyDetailSection)
    ? (value as AgencyDetailSection)
    : 'general'
}
